import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, Routes, useParams, useNavigate, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { all_routes } from "../router/all_routes";
import Header from "../Header";
import { ProductContext } from "../../context/AppContext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Spinner, Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { KJUR } from "jsrsasign";
import {
  FaBus,
  FaUserTie,
  FaMapMarkedAlt,
  FaClock,
  FaRoute,
  FaIdCard,
  FaPhone,
  FaMapPin,
  FaExclamationTriangle
} from "react-icons/fa";

const formatServiceType = (type) => {
  if (!type) return "";
  const str = String(type).trim();
  const lower = str.toLowerCase();
  if (lower === "both" || lower === "pick_and_drop" || lower === "pick & drop") {
    return "pick and drop";
  }
  return str;
};

const getSubstituteList = (item) => {
  if (!item) return [];
  const raw = item.vehicle_substitute;
  if (Array.isArray(raw)) return raw.filter(Boolean);
  if (raw && typeof raw === "object") return [raw];
  if (item.substitute_vehicle_details) return [item.substitute_vehicle_details];
  return [];
};


const TransportInfo = () => {
  const params = useParams();
  const [state, setState] = useState(null);
  const navigate = useNavigate();
  const {
    allClass = [],
    dataNew,
    getRegistration,
    setGetRegistration,
    fetchMyReegistrationData,
    GetstudentData,
    userData,
    Automationdata,
  } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");
  const [isDownloading, setIsDownloading] = useState(false);

  const routes = all_routes;
  const { id } = useParams();
  const location = useLocation();
  const { transportData } = location.state || {};

  const [holidayCalendar, setHolidayCalendar] = useState([]);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/masters/holidaycalender",
          {
            headers: {
              accept: "application/json",
              "x-auth": authtoken,
            },
          }
        );
        setHolidayCalendar(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching holiday calendar:", error);
      }
    };
    if (authtoken) {
      fetchHolidays();
    }
  }, [authtoken]);

  const checkTodayHoliday = (holidays) => {
    if (!Array.isArray(holidays) || holidays.length === 0) return null;
    const d = new Date();
    const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    return holidays.find((item) => {
      if (!item?.start_date || !item?.end_date || item?.is_deleted) return false;
      const start = item.start_date.split("T")[0];
      const end = item.end_date.split("T")[0];
      return today >= start && today <= end;
    });
  };

  const todayHoliday = checkTodayHoliday(holidayCalendar);

  return (
    <>
      <div className="page-wrapper">
        {getRegistration ? (
          <div className="content min-vh-100">
            <Header />
            <Container fluid className="py-4">
              {/* Page Header */}
              <Row className="mb-4">
                <Col xs={12}>
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <h2 className="mb-1 fw-bold text-primary">
                        <FaBus className="me-2" />
                        Transport Details
                      </h2>
                      <p className="text-muted mb-0">View your assigned transport information, driver details, and route.</p>
                    </div>
                   
                   
                  </div>
                </Col>
              </Row>

              {/* Transport Data Cards */}
              {transportData?.data?.length > 0 ? (
                transportData.data.map((transportItem, index) => {
                  const latestExitDetail =
  transportItem.vehicle_exit_details?.length > 0
    ? [...transportItem.vehicle_exit_details].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      )[0]
    : null;

    const latestStoppageReachTime =
  latestExitDetail?.stoppage_reach_time || "--";

const latestDropStoppageReachTime =
  latestExitDetail?.drop_stoppage_reach_time || "--";

  const driverName =
  transportItem?.substitute_vehicle_details?.driver_name ||
  transportItem?.driver_details?.morningShiftDriver?.staff_full_name;

const driverPhone =
  transportItem?.substitute_vehicle_details?.driver_contact_no ||
  transportItem?.vehicle_details?.driver_contact_no ||
  transportItem?.driver_details?.morningShiftDriver?.mobile_no;

const attendeeName =
  transportItem?.substitute_vehicle_details?.attendee_name ||
  transportItem?.driver_details?.morningShiftAttendee?.staff_full_name;

const attendeePhone =
  transportItem?.substitute_vehicle_details?.attendee_contact_no ||
  transportItem?.vehicle_details?.attendee_contact_no ||
  transportItem?.driver_details?.morningShiftAttendee?.mobile_no;

  const EveningattendeeName =
  transportItem?.substitute_vehicle_details?.attendee_name ||
  transportItem?.driver_details?.eveningShiftAttendee?.staff_full_name;

const EveningattendeePhone =
  transportItem?.substitute_vehicle_details?.attendee_contact_no ||
  transportItem?.vehicle_details?.attendee_contact_no ||
  transportItem?.driver_details?.eveningShiftAttendee?.mobile_no;



                  return(
                
                  <Row key={index} className="g-4 mb-4">
                    <div className="text-end">
                      {(() => {
                        const subList = getSubstituteList(transportItem);
                        const subUrl = subList.find(s => s?.substitute_vehicle_route_url)?.substitute_vehicle_route_url;
                        const trackUrl = subUrl || transportItem?.vehicle_details?.vehicle_route_url;
                        return trackUrl ? (
                          <a
                            href={trackUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-sm rounded-pill"
                            onClick={(e) => {
                              if (todayHoliday) {
                                e.preventDefault();
                                Swal.fire({
                                  icon: "info",
                                  title: "School Holiday Today",
                                  text: `Live tracking is not available today due to holiday: ${todayHoliday.title || 'Holiday'}.`,
                                  confirmButtonColor: "#3085d6",
                                });
                              }
                            }}
                          >
                            <FaMapMarkedAlt className="me-1" /> Locate Route
                          </a>
                        ) : null;
                      })()}
                    </div>
                    {/* Driver Details Card */}
                    <Col md={3}>
                      <Card className="h-100 shadow-sm border-0 rounded-4">
                        <Card.Header className="bg-primary text-white rounded-top-4">
                          <div className="d-flex align-items-center">
                            <FaUserTie className="me-2" />
                            <h6 className="mb-0 fw-bold text-white">Driver Details</h6>
                          </div>
                        </Card.Header>
                        <Card.Body className="p-3">
                          <Row>
                            <Col xs={12}>
                            {transportItem?.driver_details?.morningShiftDriver && (
                              <>
                              <div className="mb-2">
                                <h2 style={{fontSize:'16px'}}>
                                      {transportItem?.substitute_vehicle_details ? "Substitute Driver" : "Morning Shift"}
                                </h2>
                                <small className="text-muted d-block">Name</small>
                                <strong className="d-block text-dark">
                                  {driverName || "--"}
                                </strong>
                              </div>
                              <div className="mb-3">
                                <small className="text-muted d-block">Phone</small>
                                <strong className="d-block text-dark">
                                  <a href={`tel:${driverPhone}`}>
      {driverPhone || "--"}
    </a>
                                </strong>
                              </div>
                              </>
                            )}
                              {transportItem?.driver_details?.eveningShiftDriver && (
<>
                              <div className="mb-2">
                                <h2 style={{fontSize:'16px'}}>Evening Shift</h2>
                                <small className="text-muted d-block">Name</small>
                                <strong className="d-block text-dark">
                                  {transportItem?.driver_details?.eveningShiftDriver?.staff_full_name || '--'}
                                </strong>
                              </div>
                              <div className="mb-3">
                                <small className="text-muted d-block">Phone</small>
                                <strong className="d-block text-dark">
                                  <a href={`tel:${transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.eveningShiftDriver?.mobile_no}`}>
  {transportItem?.vehicle_details?.driver_contact_no || transportItem?.driver_details?.eveningShiftDriver?.mobile_no || '--'}
</a>
                                </strong>
                              </div>
                              </>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col md={3}>
                      <Card className="h-100 shadow-sm border-0 rounded-4">
                        <Card.Header className="bg-primary text-white rounded-top-4">
                          <div className="d-flex align-items-center">
                            <FaUserTie className="me-2" />
                            <h6 className="mb-0 fw-bold text-white">Attendee Details</h6>
                          </div>
                        </Card.Header>
                        <Card.Body className="p-3">
                          <Row>
                            <Col xs={12}>
                            {transportItem?.driver_details?.morningShiftAttendee && (
                              <>
                              <div className="mb-2">
                                <h2 style={{fontSize:'16px'}}>
                                      {transportItem?.substitute_vehicle_details ? "Substitute Attendee" : "Morning Shift"}

                                </h2>
                                <small className="text-muted d-block">Name</small>
                                <strong className="d-block text-dark">
                                  {attendeeName || "--"}
                                </strong>
                              </div>
                              <div className="mb-3">
                                <small className="text-muted d-block">Phone</small>
                                <strong className="d-block text-dark">
                                  <a href={`tel:${attendeePhone}`}>
                                      {attendeePhone || "--"}
                                    </a>
                                </strong>
                              </div>
                              </>
                            )}
                              {transportItem?.driver_details?.eveningShiftAttendee && (
<>
                              <div className="mb-2">
                                <h2 style={{fontSize:'16px'}}>Evening Shift</h2>
                                <small className="text-muted d-block">Name</small>
                                <strong className="d-block text-dark">
                                  {EveningattendeeName || '--'}
                                </strong>
                              </div>
                              <div className="mb-3">
                                <small className="text-muted d-block">Phone</small>
                                <strong className="d-block text-dark">
                                  <a href={`tel:${EveningattendeePhone}`}>
  {EveningattendeePhone || '--'}
</a>
                                </strong>
                              </div>
                              </>
                              )}
                              
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    

                    {/* Bus Information Card */}
                    <Col md={3}>
                      <Card className="h-100 shadow-sm border-0 rounded-4">
                        <Card.Header className="bg-info text-white rounded-top-4">
                          <div className="d-flex align-items-center">
                            <FaBus className="me-2" />
                            <h6 className="mb-0 fw-bold text-white">Bus Information</h6>
                          </div>
                        </Card.Header>
                        <Card.Body className="p-3">
                          <Row className="">
                            <Col xs={12}>
                              <div className="text-start mb-3">
                                <Badge bg="light" text="dark" className="px-3 py-2">
                                  <FaIdCard className="me-1" /> Vehicle ID: {transportItem?.vehicle_details?.id || 'N/A'}
                                </Badge>
                              </div>
                            </Col>
                            {(() => {
                              const subList = getSubstituteList(transportItem);
                              if (subList.length > 0) {
                                return (
                                  <>
                                    {subList.map((sub, sIdx) => (
                                      <React.Fragment key={sIdx}>
                                        <Col xs={12} className="mb-2">
                                          <small className="text-muted d-block">Bus No.</small>
                                          <strong className="d-block text-dark">
                                            {sub?.substitute_vehicle_number || ''} 
                                            <Badge bg="success" className="fs-10 mt-1 mb-0 ms-1">Substitute</Badge>
                                          </strong>
                                        </Col>
                                        <Col xs={6}>
                                          <small className="text-muted d-block">Date</small>
                                          <strong className="d-block text-dark">
                                            <Badge bg="secondary" className="px-2 py-1">
                                              {sub?.substitute_date || 'N/A'}
                                            </Badge>
                                          </strong>
                                        </Col>
                                        <Col xs={6}>
                                          <small className="text-muted d-block">Trip</small>
                                          <strong className="d-block text-dark">
                                            <Badge bg="secondary" className="px-2 py-1 text-capitalize">
                                              {formatServiceType(sub?.trip) || 'N/A'}
                                            </Badge>
                                          </strong>
                                        </Col>
                                      </React.Fragment>
                                    ))}
                                    <div style={{fontSize:'12px'}}>
                                      <Col xs={12}>
                                        <small className="text-muted d-block mt-2">Original Bus No.</small>
                                        <strong className="d-block text-dark">
                                          {transportItem?.vehicle_details?.vehicle_number || 'N/A'}
                                        </strong>
                                      </Col>
                                      <Col xs={12}>
                                        <small className="text-muted d-block">Service Type</small>
                                        <strong className="d-block text-dark">
                                          <Badge bg="secondary" className="px-2 py-1 text-capitalize">
                                            {formatServiceType(transportItem?.service_type) || 'N/A'}
                                          </Badge>
                                        </strong>
                                      </Col>
                                    </div>
                                  </>
                                );
                              }
                              return (
                                <>
                                  <Col xs={12}>
                                    <small className="text-muted d-block">Bus No.</small>
                                    <strong className="d-block text-dark">
                                      {transportItem?.vehicle_details?.vehicle_number || 'N/A'}
                                    </strong>
                                  </Col>
                                  <Col xs={12}>
                                    <small className="text-muted d-block">Service Type</small>
                                    <strong className="d-block text-dark">
                                      <Badge bg="secondary" className="px-2 py-1 text-capitalize">
                                        {formatServiceType(transportItem?.service_type) || 'N/A'}
                                      </Badge>
                                    </strong>
                                  </Col>
                                </>
                              );
                            })()}
                            {/* <Col xs={12}>
                              <small className="text-muted d-block">Capacity</small>
                              <strong className="d-block text-dark">
                                {transportItem?.vehicle_details?.no_of_seats || 'N/A'} Seats
                              </strong>
                            </Col> */}
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Stoppage Details Card */}
                    <Col md={3}>
                      <Card className="h-100 shadow-sm border-0 rounded-4">
                        <Card.Header className="bg-warning text-dark rounded-top-4">
                          <div className="d-flex align-items-center">
                            <FaMapPin className="me-2 text-white"  />
                            <h6 className="mb-0 fw-bold text-white">Stoppage Details</h6>
                          </div>
                        </Card.Header>
                        <Card.Body className="p-3">
                          <Row className="g-3">
                            <Col xs={12}>
                              <div className="mb-3">
                                <small className="text-muted d-block">Route Name</small>
                                <strong className="d-block text-dark fw-bold">
                                  #{transportItem?.route_details?.code} {transportItem?.route_details?.startplace} - {transportItem?.route_details?.endplace}
                                </strong>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <div className="mb-3">
                                <small className="text-muted d-block">Stop Name</small>
                                <strong className="d-block text-dark fw-bold">
                                  #{transportItem?.stoppage_details?.id} {transportItem?.stoppage_details?.stop_name || 'N/A'}
                                </strong>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <small className="text-muted d-block">Expected Reach Time</small>
                              <div className="d-flex align-items-center">
                                <FaClock className="me-2 text-primary" />
                                <strong className="text-dark">
                                  {latestStoppageReachTime}
                                </strong>
                              </div>
                            </Col>
                            <Col xs={12}>
                              <small className="text-muted d-block">Stoppage Reach Time</small>
                              <div className="d-flex align-items-center">
                                <FaClock className="me-2 text-primary" />
                                <strong className="text-dark">
                                  {latestDropStoppageReachTime}
                                </strong>
                              </div>
                            </Col>
                            {/* <Col xs={12}>
                              <small className="text-muted d-block">Route Distance</small>
                              <strong className="d-block text-dark">
                                {transportItem?.stoppage_details?.distance || 'N/A'} km
                              </strong>
                            </Col> */}
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )})
              ) : (
                <Row className="justify-content-center">
                  <Col xs={12} md={8}>
                    <Card className="text-center py-5 border-0 shadow-sm rounded-4">
                      <FaExclamationTriangle size={64} className="text-muted mb-3" />
                      <h4 className="text-muted mb-2">No Transport Assigned</h4>
                      <p className="text-muted mb-4">You are not assigned to any transport route at the moment.</p>
                      <Button variant="outline-primary" onClick={() => navigate(-1)}>
                        <FaRoute className="me-1" /> Back to Dashboard
                      </Button>
                    </Card>
                  </Col>
                </Row>
              )}
            </Container>
          </div>
        ) : (
          <div className="content d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <Header />
            <Container className="text-center">
              <Spinner animation="border" role="status" className="mb-3">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <h5 className="text-muted">Loading Transport Information...</h5>
            </Container>
          </div>
        )}
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .page-wrapper {
          background-color: #f8f9fa;
        }
        .content {
          padding: 20px 0;
        }
        .card {
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        }
        .rounded-4 {
          border-radius: 1rem !important;
        }
        @media (max-width: 768px) {
          .card-body {
            padding: 1rem;
          }
          .btn {
            width: 100%;
            margin-top: 0.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default TransportInfo;